import Hero from "@/components/Hero";
import CollectionsGrid from "@/components/CollectionsGrid";
import EditorialSection from "@/components/EditorialSection";
import NewArrivals from "@/components/NewArrivals";
import Testimonials from "@/components/Testimonials";
import BridalAppointment from "@/components/BridalAppointment";
import InstagramFeed from "@/components/InstagramFeed";
import { useSite } from "@/context/SiteContext";

export default function Home() {
  const { settings } = useSite();
  const s = settings.home.sections || {};
  return (
    <div data-testid="home-page">
      <Hero />
      <CollectionsGrid />
      {s.editorial !== false && <EditorialSection />}
      {s.new_arrivals !== false && <NewArrivals />}
      {s.bridal !== false && <BridalAppointment />}
      {s.testimonials !== false && <Testimonials />}
      {s.instagram !== false && <InstagramFeed />}
    </div>
  );
}
